
import { Vue } from 'vue-property-decorator'
import { ApplicationService } from '@/store'
import { GeneralError } from '@/store/entities'
import Component from 'vue-class-component'
import ComponentLoadingSpinner from '@/commons/components/core/ComponentLoadingSpinner.vue'
import { StatusResponse } from '@/commons/constants/status.response'

@Component({
    components: {
        ComponentLoadingSpinner
    }
})
export default class PreviousApplications extends Vue {
    previousApplications: Record<string, string>[] | null = []
    loadingInProgress = false

    async fetchPreviousApplications (): Promise<void> {
        this.loadingInProgress = true
        try {
            this.previousApplications = await ApplicationService.getPreviousDocumentApplications()
        } catch {
            throw new GeneralError(['errors.system.title'])
        } finally {
            this.loadingInProgress = false
        }
    }

    getDocumentType (type: string): string {
        return ApplicationService.getDocumentTypeAsString(type)
    }

    getDocumentStatus (statusDesc: string): string {
        return ApplicationService.getStatusFromApplicationStatus(statusDesc.toLowerCase())
    }

    getDateSubmitted (dateOfSubmission: string): string {
        return ApplicationService.formatJsonDate(dateOfSubmission)
    }

    isInProcess (statusDescription: string): boolean {
        return statusDescription === StatusResponse.IN_PROCESS
    }

    isNotPaid (statusDescription: string): boolean {
        return statusDescription === StatusResponse.PAYMENT
    }

    mounted (): void {
        this.fetchPreviousApplications()
    }
}
